"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMatrixTabColumnsAndRows = exports.convertOverviewColumnsAndRows = void 0;
var columns_1 = require("../editableList/columns");
var utils_1 = require("../editableList/utils");
function convertOverviewColumnsAndRows(definitions) {
    var data = [];
    definitions.forEach(function (series_definition) {
        var series = {
            key: series_definition.key,
            color: series_definition.color,
            values: series_definition.values.map(function (value_definition) {
                return {
                    label: value_definition.label,
                    value: value_definition.value,
                    type: value_definition.type,
                    rows: value_definition.rows.map(function (r) { return (0, utils_1.dispatchRow)(r); }),
                    columns: value_definition.columns.map(function (c) { return (0, columns_1.dispatchColumn)(c); }),
                    headers: value_definition.headers,
                };
            }),
        };
        data.push(series);
    });
    return data;
}
exports.convertOverviewColumnsAndRows = convertOverviewColumnsAndRows;
function convertMatrixTabColumnsAndRows(definitions) {
    var data = [];
    definitions.forEach(function (matrix_result) {
        var matrix = {
            name: matrix_result.name,
            unit: matrix_result.unit,
            explicit_evaluation: matrix_result.explicit_evaluation,
            is_opportunity: matrix_result.is_opportunity,
            defs: matrix_result.defs,
            evals: matrix_result.evals.map(function (eval_definition) {
                return {
                    var_total: eval_definition.var_total,
                    evaluations: eval_definition.evaluations,
                    eval: eval_definition.eval,
                    eval_type: eval_definition.eval_type,
                    headers: eval_definition.headers,
                    rows: eval_definition.rows.map(function (r) { return (0, utils_1.dispatchRow)(r); }),
                    columns: eval_definition.columns.map(function (c) { return (0, columns_1.dispatchColumn)(c); }),
                };
            })
        };
        data.push(matrix);
    });
    return data;
}
exports.convertMatrixTabColumnsAndRows = convertMatrixTabColumnsAndRows;
